@if (promotionData != undefined) {
  @if (promotionData.promotionType != ePromotionType.PercentageDiscount) {
    <span class="small promotion mt-2">{{ promotionData.perQuantity }}+{{ promotionData.additionQuantity }}</span>
  }
}
